(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
			function flickityScroll(thisData){
              var flktycarousel = thisData.data('flickity');
              var lastCell = false,firstCell=false;
              flktycarousel.on('cellSelect', function(){
                var friction = (flktycarousel.options['friction'] + 0.1) * 1000;
                setTimeout(function(){
                  var fullSize = flktycarousel.slideableWidth,
                      viewport = flktycarousel.size['width'],
                      cellWidth = flktycarousel.selectedSlide['outerWidth'],
                      movedX = Math.round(flktycarousel.x);
                  fullSize = Math.round(fullSize);
                  cellWidth = Math.round(cellWidth);
                  movedX = Math.abs(movedX);
                  var total = Math.round((viewport + movedX) / 100) * 100,
                      fullSize = Math.round(fullSize / 100) * 100;
                  thisData.find('.flickity-prev-next-button.next').prop('disabled', false);
                  if(total >= fullSize){
                    if(lastCell == true)
                      //flktycarousel.select(0);
                      lastCell = true;
                    if(lastCell == true){
                      thisData.find('.flickity-prev-next-button.next').prop('disabled', true);                      
                    }
                    thisData.addClass('lastspace');
                    thisData.find('.flickity-prev-next-button.next').prop('disabled', true);
                  }else{
                    thisData.removeClass('lastspace');					
                  }
                  firstCell=false;
                  thisData.removeClass('firstspace');
                  if(movedX < 70){
                    lastCell = false;
                    firstCell = true;
                    thisData.addClass('firstspace');       
                  }
                }, friction);
              });
            }
            $('.product-carousel').each(function(e){
              var thisslider = $(this);
              $(this).flickity({pageDots: false,cellAlign:"left",contain:true});
			  flickityScroll(thisslider);
            });
			setTimeout(function() {
				$(".grid-meta").matchHeight({property:"height"});
			}, 1000);			
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
